export default __webpack_public_path__ + "static/media/plusLens.820e2a2c.svg";